import React, {PropTypes} from 'react';
import classNames from 'classnames';
import FieldValidationError from './FieldValidationError.jsx';

const DollarInputField = ({
  autoFocus,
  disabled,
  input,
  label,
  placeholder,
  step,
  min,
  style,
  meta: {
    touched,
    error
  }
}) => (
  <div className={classNames(
    'input-group',
    {'has-error': touched && error}
  )}>
    {
      label || placeholder
      ? <label style={{display: 'table-caption'}}
          htmlFor={name}>
          {label || placeholder}
        </label>
      : null
    }
    <span className="input-group-addon">$</span>
    <input
      {...input}
      autoFocus={autoFocus}
      className="form-control"
      disabled={disabled}
      min={min}
      placeholder={placeholder}
      step={step}
      type="number"
      style={style}
    />
    <FieldValidationError
      touched={touched}
      error={error}
    />
  </div>
);

DollarInputField.propTypes = {
  autoFocus: PropTypes.bool,
  input: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  meta: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  step: PropTypes.string,
  min: PropTypes.string,
  style: PropTypes.object
};

export default DollarInputField;



// WEBPACK FOOTER //
// ./src/features/shared/DollarInputField.jsx